import { useNavigate } from 'react-router-dom';
import { useAnalysisClusters, useDeleteCluster } from '../hooks/useAnalysisClusters';
import Badge from '../components/ui/Badge';
import ProjectContextBadge from '../components/layout/ProjectContextBadge';

const STATUS_BADGE = {
  draft: { bg: '#F3F4F6', color: '#6B7280', label: 'Entwurf' },
  synthesizing: { bg: '#FEF3C7', color: '#F59E0B', label: 'Synthese läuft' },
  ready: { bg: '#D1FAE5', color: '#10B981', label: 'Bereit' },
  failed: { bg: '#FEE2E2', color: '#EF4444', label: 'Fehler' },
};

export default function AnalysisClusters() {
  const navigate = useNavigate();
  const { data: clusters = [], isLoading } = useAnalysisClusters();
  const del = useDeleteCluster();

  return (
    <div>
      <div className="mb-5">
        <ProjectContextBadge />
        <h1 className="text-[23px] font-bold mb-0.5">Analyse-Cluster</h1>
        <p className="text-gray-500 text-[13.5px]">Gebündelte Synthesen aus mehreren Einzelanalysen — Muster, Widersprüche, Roadmap.</p>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-black/[.07]">
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-200 text-left">
              <th className="px-5 py-3.5 text-[12px] text-gray-500 font-medium">Titel</th>
              <th className="px-5 py-3.5 text-[12px] text-gray-500 font-medium">Disziplinen</th>
              <th className="px-5 py-3.5 text-[12px] text-gray-500 font-medium">Analysen</th>
              <th className="px-5 py-3.5 text-[12px] text-gray-500 font-medium">Status</th>
              <th className="px-5 py-3.5 text-[12px] text-gray-500 font-medium">Provider</th>
              <th className="px-5 py-3.5 text-[12px] text-gray-500 font-medium">Aktualisiert</th>
              <th className="px-5 py-3.5 text-[12px] text-gray-500 font-medium text-right">Aktion</th>
            </tr>
          </thead>
          <tbody>
            {clusters.map((c) => {
              const st = STATUS_BADGE[c.status] || STATUS_BADGE.draft;
              return (
                <tr
                  key={c.id}
                  className="border-b border-gray-100 last:border-0 hover:bg-gray-50/50 cursor-pointer"
                  onClick={() => navigate(`/cro/clusters/${c.id}`)}
                >
                  <td className="px-5 py-3.5 text-[13px] font-medium">{c.title}</td>
                  <td className="px-5 py-3.5 text-[12px] text-gray-500">{c.discipline_mix || '—'}</td>
                  <td className="px-5 py-3.5 text-[12px] text-gray-600">{c.analyses?.length ?? 0}</td>
                  <td className="px-5 py-3.5"><Badge bg={st.bg} color={st.color}>{st.label}</Badge></td>
                  <td className="px-5 py-3.5 text-[12px] text-gray-500">{c.provider || '—'}</td>
                  <td className="px-5 py-3.5 text-[12px] text-gray-500">{new Date(c.updated_at).toLocaleDateString('de')}</td>
                  <td className="px-5 py-3.5 text-right" onClick={(e) => e.stopPropagation()}>
                    <button
                      onClick={() => { if (confirm('Cluster löschen?')) del.mutate(c.id); }}
                      className="text-[12px] text-red-500 hover:text-red-700 font-medium"
                    >
                      Löschen
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {clusters.length === 0 && !isLoading && (
          <div className="py-12 text-center text-gray-400 text-sm">
            Noch keine Cluster. Wähle in der Analysen-Liste mehrere Analysen aus und klicke „Cluster bilden".
          </div>
        )}
      </div>
    </div>
  );
}
